module.exports = __webpack_public_path__ + "img/pingjia3.f47d31ac.png";